const LAST_COMMA = /,(?=[^,]*$)/;

export const joinWithComma = (list?: string[], andTranslated?: string) =>
  list ? list.join(', ').replace(LAST_COMMA, ` ${andTranslated} `) : undefined;
